import LoginComponent from './login.component';

angular
	.module('app.login', [])
	.component('appLogin', LoginComponent);
